import { render, staticRenderFns } from "./AgricultureMainSection.vue?vue&type=template&id=433cfc1e"
import script from "./AgricultureMainSection.vue?vue&type=script&lang=js"
export * from "./AgricultureMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports